import type { ReactNode } from 'react'
import { Loader2 } from 'lucide-react'
import { AppHeader } from './AppHeader'
import { cn } from '../lib/utils'

/** Page frame for a shared-link landing (`/join`, `/add`, `/t`): header with a home back link, centered column. */
export function LinkLandingShell({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className="min-h-full bg-background">
      <AppHeader back="/" />
      <main className={cn('max-w-2xl mx-auto px-4 py-16 flex flex-col items-center gap-4 text-center', className)}>
        {children}
      </main>
    </div>
  )
}

/** The landing while the link is still resolving. */
export function LinkLandingSpinner({ label }: { label: ReactNode }) {
  return (
    <LinkLandingShell className="gap-3">
      <Loader2 className="size-5 animate-spin text-muted-foreground" />
      <p className="text-sm text-muted-foreground">{label}</p>
    </LinkLandingShell>
  )
}

/** A terminal landing state — invalid link, your own link, nothing to show yet. */
export function LinkLandingMessage({
  title,
  body,
  action,
  media,
}: {
  title: ReactNode
  body: ReactNode
  action: ReactNode
  /** Shown above the title (an avatar, a totem). */
  media?: ReactNode
}) {
  return (
    <LinkLandingShell>
      {media}
      <div className="space-y-2">
        <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{body}</p>
      </div>
      {action}
    </LinkLandingShell>
  )
}
